import Swiper from 'swiper/bundle';

import Section from "../Section";
import KenBurns from "../global/KenBurns";

export default class BlogPosts extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.kenBurns = new KenBurns(theme, element);
    const swiperContainer = this.element.querySelector('.swiper');
    this.swiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      watchOverflow: true,
      autoHeight: true,
      spaceBetween: 16,
      pagination: {
        el: swiperContainer.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
  }
}
